<template>
  <div class="supporterCandidate">
    <div class="row align-center column-s">
      <h1><!-- <i class="fa-solid fa-pen-to-square" />  -->Candidatos</h1>
      &nbsp;&nbsp;&nbsp;
      <Button
        :layout="showCandidate ? 'red-go' : 'green-go'"
        title="NOVO CANDIDATO"
        @click="showCandidate = !showCandidate"
        >{{ showCandidate ? "x" : "+" }}</Button
      >
      &nbsp;&nbsp;&nbsp;&nbsp;
      <form
        v-if="showCandidate"
        class="row justify-space align-center-s align-end column-s grid-9"
        onsubmit="return false"
        @submit="newCandidate"
      >
        <div class="column grid-3 grid-12-s">
          <label>Nome</label>
          <input class="input" placeholder="Nome" v-model="form.nome" required />
        </div>
        <div class="column grid-4 grid-12-s">
          <label>E-mail</label>
          <input class="input" placeholder="E-mail" v-model="form.email" required />
        </div>
        <div class="column grid-3 grid-12-s">
          <label>Celular</label>
          <input
            v-mask="'(##) #####-####'"
            class="input"
            placeholder="Celular"
            v-model="form.celular"
            required
          />
        </div>

        <Button layout="green-go" type="submit" :loader="loader.form">ADICIONAR</Button>
      </form>
    </div>

    <div class="list">
      <div v-if="loader.candidates" class="column align-center justify-center">
        <Loader layout="small" />
      </div>
      <template v-else>
        <input
          class="input search"
          v-model="search"
          placeholder="Pesquisar Nome ou E-mail"
        />

        <div class="head row justify-space">
          <div class="grid-4">NOME</div>
          <div class="grid-4">E-MAIL</div>
          <div class="grid-2">CRIADO EM</div>
          <div class="grid-1"></div>
        </div>
        <div class="content">
          <div
            v-for="(cand, i) of filteredCandidates"
            class="row line justify-space"
            :key="'cand' + i"
          >
            <div class="grid-4">{{ cand.nome }}</div>
            <div class="grid-4">{{ cand.email }}</div>
            <div class="grid-2">{{ cand.criado_em | date }}</div>
            <div class="grid-1">
              <Button layout="red-go" @click="delCandidate(cand.id)"
                ><i class="fa fa-trash" /> Excluir</Button
              >
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";
export default {
  name: "SupporterCandidate",
  components: {
    Button,
    Loader,
  },
  data() {
    return {
      showCandidate: false,
      search: "",
      loader: {
        form: false,
        candidates: true,
      },
      candidates: [],
      form: {
        nome: "",
        celular: "",
        email: "",
      },
    };
  },
  beforeMount() {
    this.loadCandidates();
  },
  mounted() {
    this.$parent.$children[0].changeMenu("candidates");
  },
  methods: {
    ...mapActions("user", [
      "CREATE_SUPPORTER",
      "CANDIDATES_SUPPORTER",
      "DEL_CANDIDATE_SUPPORTER",
    ]),
    loadCandidates() {
      this.loader.candidates = true;
      this.CANDIDATES_SUPPORTER({})
        .then(({ data }) => {
          this.candidates = data;
          this.loader.candidates = false;
        })
        .catch(() => {
          this.loader.candidates = false;
        });
    },
    newCandidate() {
      this.loader.form = true;
      this.CREATE_SUPPORTER(this.form)
        .then(({ status }) => {
          if (status == 201) {
            this.loadCandidates();
            this.form = {
              nome: "",
              celular: "",
              email: "",
            };
          }
          this.loader.form = false;
        })
        .catch(() => {
          this.loader.form = false;
        });
    },
    delCandidate(ID) {
      if (confirm("Deseja excluir este candidato?")) {
        this.loader.candidates = true;
        this.DEL_CANDIDATE_SUPPORTER(ID)
          .then(() => {
            this.loadCandidates();
          })
          .catch(() => {
            this.loader.candidates = false;
          });
      }
    },
  },
  computed: {
    filteredCandidates() {
      if (this.search) {
        const search = this.search.toLowerCase();

        return this.candidates.filter((part) => {
          let partsSerialize = JSON.stringify(part).toLowerCase();
          return partsSerialize.includes(search);
        });
      } else {
        return this.candidates;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.supporterCandidate
    @include page
    form
      margin-top: -21px
      label
        @include label
        @media (max-width: $small)
          margin-top: 20px
      button
        margin: 9px
        @media (max-width: $small)
          margin-top: 33px
    .loader
      margin: 31px
    .list
      @include card
      margin-top:21px
      .search
        width: 400px
        height: 40px
        margin-bottom: 50px
        border-bottom: 1.9px solid #999
        box-shadow: none
        border-radius: 0
        &:focus
          border-bottom: 1.9px solid $supporter-1
          color: $supporter-1
          background: none
      @media (max-width: $small)
        width: 85%
        overflow: auto

      .head
          color: $purple
          font-size: 14px
          font-weight: bold
          @media (max-width: $small)
            min-width: 1000px
      .content
        max-height: 375px
        overflow-y: auto
        margin-top: 12px
        @media (max-width: $small)
          min-width: 1000px
        .line
          margin-top: 17px
          padding: 9px
</style>
